export const CATEGORY_LABELS: Record<string, string> = {
  'ai-filmmaking': 'AI Filmmaking',
  tutorials: 'Tutorials',
  'industry-news': 'Industry News',
  'case-studies': 'Case Studies',
  'product-updates': 'Product Updates',
}
